import { useState, useEffect } from 'react';

export default function Preloader() {
  const [visible, setVisible] = useState(true);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setExiting(true);
      setTimeout(() => setVisible(false), 600);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[200] flex items-center justify-center bg-background-50 transition-all duration-600 ${
        exiting ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-4">
        {/* Animated coffee cup */}
        <div className="relative w-16 h-16 md:w-20 md:h-20">
          <div className="w-full h-full flex items-center justify-center rounded-full bg-primary-100 animate-pulse">
            <i className="ri-cup-line text-primary-500 text-2xl md:text-3xl"></i>
          </div>
          {/* Steam rings */}
          <div className="absolute -top-2 left-1/2 -translate-x-1/2">
            <div className="w-1.5 h-4 bg-primary-300/60 rounded-full animate-[steam_1.2s_ease-out_infinite]"></div>
          </div>
          <div className="absolute -top-3 left-[60%] -translate-x-1/2">
            <div className="w-1 h-3 bg-primary-300/40 rounded-full animate-[steam_1.2s_ease-out_0.3s_infinite]"></div>
          </div>
          <div className="absolute -top-1 left-[40%] -translate-x-1/2">
            <div className="w-1 h-3.5 bg-primary-300/50 rounded-full animate-[steam_1.2s_ease-out_0.6s_infinite]"></div>
          </div>
        </div>
        <span className="font-heading text-lg font-bold text-foreground-200 tracking-wide">
          Guma Bar
        </span>
      </div>
    </div>
  );
}